import React from 'react';
//import shortid from 'shortid';
export default class FacebookShareWidget extends React.Component {
    constructor(props) {
        super(props);
        this.props=props;
        this.state = {
            hovered:false,
            maskid:"hole_"+"facebook_"+(props.uniqueId || '1')
        };
        
        this.handleMouseOver=this.handleMouseOver.bind(this);
        this.handleMouseOut=this.handleMouseOut.bind(this);
        this.handleClick=this.handleClick.bind(this);
    }
    componentDidMount() {
        this.refs.thecircle.setAttribute("mask","url(#" + this.state.maskid + ")");                
    }
    handleMouseOver() {
        this.setState({hovered:true});
    }
    handleMouseOut() {
        this.setState({hovered:false});
    }
    getShareLink() {
        return "http://www.facebook.com/sharer.php?s=100"+
            "&p[title]="+(this.props.title || "")+
            "&p[summary]="+(this.props.description || "")+
            "&u="+(this.props.url || "");
    }
    handleClick(event) {
        if(window && screen) {
            let winWidth = 520, 
                winHeight = 350, 
                winTop = (screen.height / 2) - (winHeight / 2),
                winLeft = (screen.width / 2) - (winWidth / 2);
            window.open(this.getShareLink(),null,
                'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
        }
        event.preventDefault();
    }
    render() {
        let props=this.props;
        return(
            <a onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}  href={this.getShareLink()}
                target="_blank"
                onClick={this.handleClick}
            >
                <span className={"btn-floating waves-effect waves-light"} style= {{backgroundColor:"#f2f2f2!important"}}>
                    <svg width="100%" height={props.size||null} viewBox="0 0 32 32">
                        <defs>
                            <mask id={this.state.maskid}>
                                <rect width="100%" height="100%" fill="white"/>
                                <g>
                                    <path d="M17,11.5c0-0.3,0.2-0.5,0.5-0.5h2V8H16c-1.4,0-2.5,1.1-2.5,2.5        v3H12v3h1.5V24H17v-7.5h2l0.5-3H17V11.5z"/>
                                </g>
                            </mask>
                        </defs>
                        <circle ref="thecircle" cx="16" cy="16" r="15" mask={"url(#" + this.state.maskid + ")"}
                            style={{
                                fill:(this.state.hovered&&this.props.highlightMode=="outer")?"#6d84b4":"#2b2b2b"     
                            }}
                        />
                        <g>
                            <path ref="thesymbol"
                                style={{
                                    fill:(this.state.hovered&&this.props.highlightMode=="inner")?"#6d84b4":"none"
                                }} 
                                d="M17,11.5c0-0.3,0.2-0.5,0.5-0.5h2V8H16c-1.4,0-2.5,1.1-2.5,2.5        v3H12v3h1.5V24H17v-7.5h2l0.5-3H17V11.5z"
                            />
                        </g>
                    </svg>    
                </span>
            </a>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/components/FacebookShareWidget/FacebookShareWidget.jsx